import React, { useState, useEffect } from 'react';
import './TitleScreen.css';

const ASCII_LOGO = `
 ██████╗ ██╗    ██╗ █████╗ ███████╗██████╗ 
██╔═══██╗██║    ██║██╔══██╗██╔════╝██╔══██╗
██║   ██║██║ █╗ ██║███████║███████╗██████╔╝
██║   ██║██║███╗██║██╔══██║╚════██║██╔═══╝ 
╚██████╔╝╚███╔███╔╝██║  ██║███████║██║     
 ╚═════╝  ╚══╝╚══╝ ╚═╝  ╚═╝╚══════╝╚═╝     

██████╗  ██████╗ ██╗   ██╗███╗   ██╗████████╗██╗   ██╗
██╔══██╗██╔═══██╗██║   ██║████╗  ██║╚══██╔══╝╚██╗ ██╔╝
██████╔╝██║   ██║██║   ██║██╔██╗ ██║   ██║    ╚████╔╝ 
██╔══██╗██║   ██║██║   ██║██║╚██╗██║   ██║     ╚██╔╝  
██████╔╝╚██████╔╝╚██████╔╝██║ ╚████║   ██║      ██║   
╚═════╝  ╚═════╝  ╚═════╝ ╚═╝  ╚═══╝   ╚═╝      ╚═╝   

██╗  ██╗██╗   ██╗███╗   ██╗████████╗███████╗██████╗ 
██║  ██║██║   ██║████╗  ██║╚══██╔══╝██╔════╝██╔══██╗
███████║██║   ██║██╔██╗ ██║   ██║   █████╗  ██████╔╝
██╔══██║██║   ██║██║╚██╗██║   ██║   ██╔══╝  ██╔══██╗
██║  ██║╚██████╔╝██║ ╚████║   ██║   ███████╗██║  ██║
╚═╝  ╚═╝ ╚═════╝ ╚═╝  ╚═══╝   ╚═╝   ╚══════╝╚═╝  ╚═╝`;

const AGENT_ASCII = `
      ┌───────┐
      │ ◉   ◉ │
      │   ▼   │
      │ ╰───╯ │
      └───┬───┘
          │
      ┌───┴───┐
      │ AGENT │
      │ ▓▓▓▓▓ │
      └───────┘
         ║║
        ╔╩╩╗
        ╚══╝`;

const TitleScreen = ({ onStart }) => {
  const [showPrompt, setShowPrompt] = useState(true);
  const [bootText, setBootText] = useState([]);
  const [bootComplete, setBootComplete] = useState(false);

  // Boot sequence
  useEffect(() => {
    const bootMessages = [
      '> Initializing security protocols...',
      '> Loading OWASP Top 10:2025 database...',
      '> Calibrating threat detection systems...',
      '> Establishing secure connection...',
      '> Agent clearance verified.',
      '> SYSTEM READY.'
    ];

    let index = 0;
    const timer = setInterval(() => {
      if (index < bootMessages.length) {
        setBootText(prev => [...prev, bootMessages[index]]);
        index++;
      } else {
        clearInterval(timer);
        setTimeout(() => setBootComplete(true), 500);
      }
    }, 400);

    return () => clearInterval(timer);
  }, []);

  // Blinking prompt
  useEffect(() => {
    const timer = setInterval(() => {
      setShowPrompt(prev => !prev);
    }, 500);
    return () => clearInterval(timer);
  }, []);

  const handleStart = () => {
    // Play sound effect here if we add sound
    onStart();
  };

  return (
    <div className="title-screen">
      <div className="title-content">
        {/* ASCII Logo */}
        <pre className="ascii-logo">{ASCII_LOGO}</pre>
        
        {/* Tagline */}
        <p className="tagline">
          // HUNT THE OWASP TOP 10:2025 //
        </p>

        {/* Boot Sequence */}
        <div className="boot-sequence">
          {bootText.map((text, i) => (
            <p key={i} className={`boot-line ${i === bootText.length - 1 ? 'latest' : ''}`}>
              {text}
            </p>
          ))}
        </div>

        {/* Agent and Start */}
        {bootComplete && (
          <div className="start-section">
            <pre className="agent-ascii">{AGENT_ASCII}</pre>
            
            <button className="start-button" onClick={handleStart}>
              <span className="btn-text">[ START MISSION ]</span>
            </button>
            
            <p className="prompt">
              {showPrompt ? '> Press ENTER or click to begin_' : '> Press ENTER or click to begin '}
            </p>
          </div>
        )}

        {/* Footer */}
        <div className="title-footer">
          <p>CREATED BY JEFF HEYTOW</p>
          <p className="version">v1.0 | OWASP TOP 10:2025</p>
        </div>
      </div>

      {/* Keyboard handler */}
      {bootComplete && (
        <div 
          className="keyboard-trap" 
          tabIndex={0} 
          onKeyDown={(e) => e.key === 'Enter' && handleStart()}
          autoFocus
        />
      )}
    </div>
  );
};

export default TitleScreen;
